import { render, staticRenderFns } from "./search_item.vue?vue&type=template&id=31a2c13a"
import script from "./search_item.vue?vue&type=script&lang=js"
export * from "./search_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports